
import Component, { mixins } from 'vue-class-component';
import BaseCmsBlock from '~/node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

@Component
export default class GridBlock extends mixins(BaseCmsBlock) {
  get gridSlots(): string[] {
    return Object.keys(this.$slots);
  }

  gridStyle(index: any): string {
    const _values: any = this.values;

    if (_values.columns && _values.columns.length > 0) {
      return `${_values?.columns?.[index]?.size} ${_values?.columns?.[index]?.size_m}`
    }

    return ''
  }


}
